import React, { FC } from 'react'
import styled from 'styled-components'

import { ControlPanel } from './ControlPanel'

const SettingsPanelContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 0;
  left: 64px; /* Leave space for the settings button */
  width: 350px;
  background: transparent;
  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateX(0)' : 'translateX(-420px)'};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition:
    transform 200ms ease-out,
    opacity 200ms ease-out;
`

interface HudSettingsPanelProps {
  isOpen: boolean
}

export const HudSettingsPanel: FC<HudSettingsPanelProps> = ({ isOpen }) => {
  return (
    <SettingsPanelContainer $isOpen={isOpen}>
      <ControlPanel />
    </SettingsPanelContainer>
  )
}
